export default {
	user: 'Клиент',
	admin: 'Администратор',
	manager: 'Менеджер',
	super: 'Суперадмин',
	addRole: 'Добавить роль',
	name: 'Название',
	alias: 'Алиас',
	description: 'Описание',
	permissions: 'Возможности',
	roleEdit: 'Редактирование роли',
	areYouSureYouWantToDeleteRole: 'Вы уверены, что хотите удалить роль?'
};
